import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _classCallCheck from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;
var __jsx = React.createElement;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { updateModalOpenState, clearModalState } from '../redux/modal';
import { performApiRequest, getResultData } from '../redux/apiData';
import { shadows, textStyles, colorPalette } from '../styles/styleGuide';
import { toBreakpoint } from '../styles/breakpoints';
import FormGenerator from './shared/forms/FormGenerator';
import ButtonPrimary from './shared/buttons/ButtonPrimary';
import withMatch from '@/hocs/withMatch';
var mapStateToProps = function mapStateToProps(state, ownProps) {
  var projectSlug = ownProps.match.params.projectSlug;
  return {
    feedbackResponseData: getResultData(state.apiData, 'patchFeedback', {
      projectSlug: String(projectSlug),
      feedbackId: ownProps.feedbackId
    })
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    patchFeedback: function patchFeedback(projectSlug, feedbackId, feedbackValues) {
      dispatch(performApiRequest('patchFeedback', {
        projectSlug: projectSlug,
        feedbackId: feedbackId
      }, _objectSpread({}, feedbackValues)));
    },
    onClose: function onClose() {
      dispatch(updateModalOpenState(false));
      dispatch(clearModalState());
    }
  };
};
var FeedbackModal = /*#__PURE__*/function (_Component) {
  function FeedbackModal() {
    var _this;
    _classCallCheck(this, FeedbackModal);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, FeedbackModal, [].concat(args));
    _defineProperty(_this, "state", {
      stepOne: true,
      isLoading: false,
      stepOneFadeOut: false,
      stepTwoFadeIn: false
    });
    _defineProperty(_this, "handleSubmit", function (_ref) {
      var comment = _ref.comment;
      _this.setState({
        isLoading: true
      });
      var _this$props = _this.props,
        match = _this$props.match,
        patchFeedback = _this$props.patchFeedback,
        feedbackId = _this$props.feedbackId;
      var projectSlug = String(match.params.projectSlug);
      patchFeedback(projectSlug, feedbackId, {
        comment: comment
      });
    });
    return _this;
  }
  _inherits(FeedbackModal, _Component);
  return _createClass(FeedbackModal, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.props.feedbackResponseData && this.state.isLoading) {
        this.setState({
          isLoading: false
        });
        this.goToStepTwo();
      }
    }
  }, {
    key: "goToStepTwo",
    value: function goToStepTwo() {
      var _this2 = this;
      this.setState({
        stepOneFadeOut: true
      });
      setTimeout(function () {
        _this2.setState({
          stepOne: false
        });
      }, 300);
      setTimeout(function () {
        _this2.setState({
          stepTwoFadeIn: true
        });
      }, 500);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        positive = _this$props2.positive,
        negative = _this$props2.negative,
        feedbackType = _this$props2.feedbackType,
        thanks = _this$props2.thanks,
        onClose = _this$props2.onClose;
      var isLike = feedbackType === 'like';
      var feedbackForm = [{
        options: [{
          id: 'comment',
          name: 'comment',
          required: !isLike,
          title: 'Beschrijf je ervaring hier',
          validationMessage: 'Vul hier a.u.b. je ervaring in',
          type: 'textarea'
        }]
      }];
      return __jsx(Container, {
        "data-id": "components_FeedbackModal_Container"
      }, this.state.stepOne ? __jsx(CommentContainer, {
        fadeOut: this.state.stepOneFadeOut,
        "data-id": "components_FeedbackModal_CommentContainer"
      }, __jsx(Title, {
        "data-id": "components_FeedbackModal_Title"
      }, isLike ? positive.title : negative.title), __jsx(IntroText, {
        "data-id": "components_FeedbackModal_IntroText"
      }, isLike ? positive.description : negative.description), __jsx(FormGenerator, {
        fields: feedbackForm,
        submitLabel: "Verstuur",
        loading: this.state.isLoading,
        loadingLabel: "aanvraag wordt verwerkt",
        submitFn: this.handleSubmit,
        "data-id": "components_FeedbackModal_FormGenerator"
      })) : __jsx(ThanksContainer, {
        fadeIn: this.state.stepTwoFadeIn,
        "data-id": "components_FeedbackModal_ThanksContainer"
      }, __jsx(Title, {
        "data-id": "components_FeedbackModal_Title"
      }, thanks.title), __jsx(IntroText, {
        "data-id": "components_FeedbackModal_IntroText"
      }, thanks.description), __jsx(ButtonPrimary, {
        label: "Sluit",
        type: "button",
        clickHandler: onClose,
        "data-id": "components_FeedbackModal_ButtonPrimary"
      })));
    }
  }]);
}(Component);
export default withMatch(connect(mapStateToProps, mapDispatchToProps)(FeedbackModal));
var Container = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", ";\n  background-color: #fff;\n  padding: 80rem 200rem 80rem 200rem;\n\n  ", " ", ";\n"])), shadows.boxPrimary, toBreakpoint.lg(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    padding: 80rem 70rem 60rem 70rem;\n  "]))), toBreakpoint.md(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    padding: 40rem 30rem 40rem 30rem;\n  "]))));
var Title = styled.h3(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  ", ";\n  color: ", ";\n  margin-bottom: 20rem;\n"])), textStyles.sectionTitle, colorPalette.headerGrey);
var IntroText = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  ", ";\n  color: ", ";\n  margin-bottom: 10rem;\n"])), textStyles.introText, colorPalette.textGrey);
var CommentContainer = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  transition: opacity 0.3s ease-out;\n  opacity: ", ";\n"])), function (props) {
  return props.fadeOut ? '0' : '1';
});
var ThanksContainer = styled.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  transition: opacity 0.3s ease-in;\n  opacity: ", ";\n\n  ", " {\n    margin-bottom: 40rem;\n  }\n"])), function (props) {
  return props.fadeIn ? '1' : '0';
}, IntroText);